import $ from 'jquery';

// 物件詳細の追加表示（SP）
const showPropertyDetail = () => {
    $('.pg-estate-detail__more a').on('click', (e) => {
        $('.pg-outline').addClass('is-open');
    })
}

const main = () => {
    if (document.querySelector('#page-sold-detail') === null) return;
    console.log("sold detail page");
    showPropertyDetail();
}

export default main;